module.exports = __webpack_public_path__ + "static/media/outdent.1e05ec15.svg";